<script setup lang="ts">
/**
 * Палитра быстрой навигации — оверлей по клавише `/`.
 * Открытие/закрытие — общее состояние из useNavPalette (кнопка `/` в
 * AppHeader и глобальный обработчик клавиш в App.vue управляют тем же
 * флагом). Список пунктов — useNavMenuItems, тот же, что в мобильном меню.
 */
import { useRouter } from 'vue-router'
import { useNavPalette } from '@/composables/useNavPalette'
import { useNavMenuItems } from '@/composables/useNavMenuItems'

const router = useRouter()
const { isOpen, close } = useNavPalette()
const { items } = useNavMenuItems()

function go(to: string): void {
  close()
  router.push(to)
}
</script>

<template>
  <div
    v-if="isOpen"
    class="dialog-backdrop nav-palette-backdrop"
    @click.self="close"
  >
    <div class="dialog elev-lg nav-palette">
      <div class="kicker nav-palette-header">быстрая навигация · esc чтобы закрыть</div>
      <div class="nav-palette-list">
        <button
          v-for="item in items"
          :key="item.to"
          type="button"
          class="btn btn-ghost btn-block nav-palette-item"
          @click="go(item.to)"
        >
          {{ item.label }}
          <span class="kicker">{{ item.hint }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.nav-palette-backdrop {
  z-index: 140;
  align-items: flex-start;
  padding-top: 14vh;
}

.nav-palette {
  width: min(460px, 100%);
  padding: 0;
  border: 1px solid var(--color-divider);
}

.nav-palette-header {
  padding: var(--space-3) var(--space-4);
  border-bottom: 2px solid var(--color-divider);
}

.nav-palette-list {
  padding: var(--space-2);
}

.nav-palette-item {
  margin-top: 0;
  color: var(--color-text);
  justify-content: space-between;
}
</style>
